/**
 * Shared inline markdown utility for rendering bold, italic, and code
 * in YAML-driven slide and assessment content.
 *
 * Returns an HTML string — use with `dangerouslySetInnerHTML`.
 * Safe because all content comes from our own YAML config files, not user input.
 */
export function inlineMarkdown(text: string): string {
  return text
    .replace(/\*\*(.+?)\*\*/g, '<strong class="font-semibold text-slate-900 dark:text-slate-100">$1</strong>')
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
    .replace(/`(.+?)`/g, '<code class="bg-slate-100 dark:bg-slate-700 px-1.5 py-0.5 rounded text-sm font-mono">$1</code>');
}
